import { Injectable } from '@angular/core';
import {
    NgbDateAdapter,
    NgbDateParserFormatter,
    NgbDateStruct,
} from '@cmps/ng-bootstrap';

import { DateTimeParserFormatter } from './datetime-parser-formatter';

/** this might move into the datetime-picker module */
@Injectable()
export class DateParserFormatter extends NgbDateParserFormatter {
    constructor(
        private readonly _ngbDateAdapter: NgbDateAdapter<Date>,
        private readonly _dateTimeParserFormatter: DateTimeParserFormatter,
    ) {
        super();
    }

    format(date: NgbDateStruct): string {
        const model = this._ngbDateAdapter.toModel(date);
        return this._dateTimeParserFormatter.format(model, { onlyDate: true });
    }

    parse(value: string): NgbDateStruct {
        const date = this._dateTimeParserFormatter.parse(value, {
            onlyDate: true,
        });
        return this._ngbDateAdapter.fromModel(date);
    }
}
